<body>
  <div class="grid">
    <div class="grid-item-1">
      <p class="p0">HUB Controller</p>
      <p class="p1">&#9415;</p>
    </div>
    <div class="grid-item-2">
      <p class="p3">Here is the last info we need in<br>
        order to finish your application<br></p>
    </div>
    <div class="grid-item-3">
      <p class="p2">Happy<br>Saving.</p>
    </div>
    <div class="grid-item-4"></div>
    <div class="grid-item-5">
      <form class="example-form">
        <mat-form-field>
          <input matInput class="pad" placeholder="First Name" [formControl]="firstnameFormControl">
          <mat-error *ngIf="firstnameFormControl.invalid">{{getRequiredErrorMessage()}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput class="pad" placeholder="Last Name" [formControl]="secondnameFormControl">
          <mat-error *ngIf="secondnameFormControl.invalid">{{getRequiredErrorMessage()}}</mat-error>
        </mat-form-field>
        <br><br>
        <mat-form-field>
          <input matInput class="pad" placeholder="Email" [formControl]="emailFormControl" [errorStateMatcher]="matcher">
          <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>
        <br><br>
        <mat-form-field>
          <input matInput class="pad" placeholder="Eircode" [formControl]="eircodeFormControl">
          <mat-error *ngIf="eircodeFormControl.invalid">{{getRequiredErrorMessage()}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>County</mat-label><select matNativeControl required [formControl]="countyFormControl">
            <option label="--select one --"></option>
            <option value="Carlow">Carlow</option>
            <option value="Cavan">Cavan</option>
            <option value="Clare">Clare</option>
            <option value="Cork">Cork</option>
            <option value="Donegal">Donegal</option>
            <option value="Dublin">Dublin</option>
            <option value="Galway">Galway</option>
            <option value="Kerry">Kerry</option>
            <option value="Kildare">Kildare</option>
            <option value="Kilkenny">Kilkenny</option>
            <option value="Laois">Laois</option>
            <option value="Leitrim">Leitrim</option>
            <option value="Limerick">Limerick</option>
            <option value="Longford">Longford</option>
            <option value="Louth">Louth</option>
            <option value="Mayo">Mayo</option>
            <option value="Meath">Meath</option>
            <option value="Monaghan">Monaghan</option>
            <option value="Offaly">Offaly</option>
            <option value="Roscommon">Roscommon</option>
            <option value="Sligo">Sligo</option>
            <option value="Tipperary">Tipperary</option>
            <option value="Waterford">Waterford</option>
            <option value="Westmeath">Westmeath</option>
            <option value="Wexford">Wexford</option>
            <option value="Wicklow">Wicklow</option>
            <option value="Other">Other</option>
          </select>
          <mat-error *ngIf="countyFormControl.hasError('required')">This field is required </mat-error>
          <mat-hint>Select an Option</mat-hint>
        </mat-form-field>
        <br><br>
        <mat-form-field>
          <input matInput placeholder="MPRN" [formControl]="mprnFormControl">
          <mat-error *ngIf="mprnFormControl.invalid">{{getMPRNRequiredErrorMessage()}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="BER rating" [formControl]="berFormControl">
        </mat-form-field>
        <br><br>
        <mat-form-field>
          <mat-label>No. of Heating Zones</mat-label><select matNativeControl required [formControl]="multizoneFormControl">
            <option label="--select one --"></option>
            <option value="Single Zone">Single Zone</option>
            <option value="Multizone">Multizone</option>
          </select>
          <mat-error *ngIf="multizoneFormControl.hasError('required')">This field is required </mat-error>
          <mat-hint>Select an Option</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Oil or Gas</mat-label><select matNativeControl required [formControl]="fuelFormControl">
            <option label="--select one --"></option>
            <option value="oil">Oil</option>
            <option value="gas">Gas</option>
            <option value="other">Other</option>
          </select>
          <mat-error *ngIf="fuelFormControl.hasError('required')">This field is required </mat-error>
          <mat-hint>Select an Option</mat-hint>
        </mat-form-field>
        <br><br>
        <mat-form-field *ngIf="fuelFormControl.value==fuel">
          <input matInput placeholder="GPRN" [formControl]="gprnFormControl">
        </mat-form-field>
        <br><br>
        <p>Please upload a picture of your heating controls</p>
        <input class="filewidth" type="file" (change)="getBase64($event)">
        <br><br>
        <div class="panel">
          <button mat-raised-button color="primary" id="submit" (click)="submit()">Submit</button>
        </div>
      </form>
    </div>
    <div class="grid-item-6">
      <p class="p5">Smart</p>
      <p class="p6">Thermostat</p>
    </div>
    <div class="grid-item-7">
      <p class="p2">Happy<br>Heat.</p>
    </div>
    <div class="grid-item-8">
      <p class="p3">We also need a quick a pic of your<br>
        heating controls<br></p>
    </div>
    <div class="grid-item-9"></div>
  </div>
</body>
